import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {MdDashboard,} from "react-icons/md";
import {
  FaSignOutAlt,
  FaChevronLeft,
  FaChevronRight,
  FaBook,
  FaMapMarkedAlt,
  FaUsers,
} from "react-icons/fa";
import { FaRegFolderClosed } from "react-icons/fa6";
import Source from "./SourceIMG.png";
import ProfileIMG from "./Profilpic.jpg";

const Layout = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const userRole = sessionStorage.getItem("userRole");
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState({ fullName: "", email: "" });

  const PROFIL_URL = `${process.env.REACT_APP_BE_MAIN_URL}/user/profile/`;

  const menuItems = [
    { name: "System", path: "/admin/dashboard", icon: <MdDashboard size={32} /> },
    { name: "Projects", path: "/OrgChart", icon: <FaRegFolderClosed size={32} /> },
    { name: "Drawing Intelligence", path: "/drawing-intelligence", icon: <FaMapMarkedAlt size={32} /> },
    { name: "How To", path: "/training", icon: <FaBook size={32} /> },
  ];

  const systemAdminMenuItems = [
    { name: "System", path: "/system-admin", icon: <MdDashboard size={32} /> },
    { name: "User Admin", path: "/admin/dashboard", icon: <FaUsers size={32} /> },
    { name: "Projects", path: "/OrgChart", icon: <FaRegFolderClosed size={32} /> },
    { name: "Drawing Intelligence", path: "/drawing-intelligence", icon: <FaMapMarkedAlt size={32} /> },
    { name: "How To", path: "/training", icon: <FaBook size={32} /> },
  ];

  const handleMenuClick = (item) => {
    if (item.name === "PlayBook") {
      console.log("PlayBook button clicked!");
    }
    history.push(item.path);
  }
  const userMenuItems = [
    { name: "Projects", path: "/OrgChart", icon: <FaRegFolderClosed size={32} /> },
    { name: "How To", path: "/training", icon: <FaBook size={32} /> },
  ];

  const filteredMenuItems = (() => {
    switch (userRole) {
      case "Admin":
      case "Useradmin":
        return menuItems;
      case "SystemAdmin":
      case "System Admin":
        return systemAdminMenuItems;
      default:
        return userMenuItems;
    }
  })();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await fetch(PROFIL_URL, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
          }
        });
        if (!response.ok) throw new Error("Failed to fetch profile");
        const data = await response.json();
        setUser({ fullName: data.fullName, email: data.email });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchUserProfile();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className="w-full h-screen bg-gray-100 flex relative">
      <aside
        className={`${collapsed ? "w-36" : "w-56 "
          } bg-[#1E5045]  text-[#FECF8B] p-4 flex flex-col justify-between shadow-lg transition-all duration-300`} >
        <div className="space-y-6">
          <div className="flex items-center justify-between mb-8">
            {!collapsed && (
              <img
                src={Source}
                alt="Logo"
                className="header-logo"
                style={{ width: "250px" }}
              />
            )}
            <button
              onClick={() => setCollapsed(!collapsed)}
              className="text-[#1E5045]  bg-[#FECF8B]  p-2 rounded-s-lg"
            >
              {collapsed ? (
                <FaChevronRight size={20} />
              ) : (
                <FaChevronLeft size={20} />
              )}
            </button>
          </div>
          <div className="space-y-2">
            {(filteredMenuItems || []).map((item) => {
              const active = location.pathname === item.path;

              return (
                <div key={item.name} className="relative group">
                  <button
                    className={`flex items-center w-full px-3 py-2 font-semibold transition duration-200 rounded text-left
            ${active
                        ? "bg-[#FECF8B] text-[#1E5045] hover:bg-[#FFD77D]"
                        : "hover:text-orange-400"
                      }`}
                    onClick={() => handleMenuClick(item)}
                  >
                    <span className="flex-shrink-0">{item.icon}</span>
                    {!collapsed && <span className="ml-3">{item.name}</span>}
                  </button>

                  {collapsed && (
                    <span
                      className="absolute left-14 top-1/2 transform -translate-y-1/2 
            bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                    >
                      {item.name}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Logout */}
        <div className="relative group">
          <div className=" flex justify-center items-center p-2 w-full  mb-2  ">
            <img
              src={ProfileIMG}
              alt="User Avatar"
              className="w-10 h-10 rounded-full border border-gray-300 justify-center items-center  "
            />
            {!collapsed && (
              <div className="ml-1 space-y-1 justify-center items-center">
                <p className="font-semibold text-white  first-letter:uppercase">{user.fullName}</p>
                <p className="text-sm text-gray-300 truncate max-w-[150px] overflow-hidden text-ellipsis">
                  {user.email}
                </p>
              </div>
            )}
          </div>
          <button
            className="flex items-center px-3 py-2 hover:text-red-400 text-lg font-semibold rounded"
            onClick={() => history.push("/login")}
          >
            <FaSignOutAlt size={28} className="mr-3" />
            {!collapsed && "Logout"}
          </button>

          {/* Tooltip for logout */}
          {collapsed && (
            <span
              className="absolute left-14 top-1/2 transform -translate-y-1/2 
              bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
            >
              Logout
            </span>
          )}
        </div>
      </aside>

      <main className="flex-1 flex flex-col h-screen p-6 overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default Layout;
